const current_version = "1-classicadded-2"

class RevitCarousel extends HTMLElement {
    constructor() {
        super();
        this.reviewsObj = [];
        this.revit_speed = 0.3;
        this.revit_translateX = 0;
        this.revit_keepScrolling = true;
        console.log(`Revit carousel v${current_version}`)
    }


    getJSON(url) {
        return new Promise((resolve, reject) => {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'text';
            xhr.onload = () => {
                var status = xhr.status;
                if (status === 200) {
                    resolve(xhr.response);
                } else {
                    reject(status);
                }
            };
            xhr.onerror = () => reject(xhr.status);
            xhr.send();
        });
    }

    async loadReviews() {
        const instanceId = this.getAttribute('instanceId');
        const viewMode = this.getAttribute('viewMode');
        console.log(`store:${instanceId}`);
        console.log(`viewMode:${viewMode}`);

        if (viewMode === 'Editor' || viewMode === 'Preview' || viewMode === 'Dev') {
            this.reviewsObj = this.getPreviewReviews(viewMode);
            if (viewMode === 'Dev') {
                this.revit_speed = 0;
            }

        }
        try {
            const result = await this.getJSON(`https://storage.googleapis.com/wix_carousel_reviews/${instanceId}`);
            this.reviewsObj = JSON.parse(result);
            console.log(`Loading reviews ${this.reviewsObj.reviews.length}`);

        } catch (err) {
            console.error(err);
        }

        this.render(); // Only render here when data is loaded
        this.setSpeed(this.reviewsObj)
    }

    connectedCallback() {
        this.loadReviews();
    }

    getPreviewReviews(viewMode) {
        const reviews = [];
        for (let i = 0; i < 50; i++) {
            reviews.push({
                "name": "Example Reviewer",
                "picture": "https://picsum.photos/200/300",
                "stars": 5,
                "link": "",
                "update_time_human": "1 day ago",
                "comment": "To connect your Google account and set up the widget, click on the settings icon and select the 'Open Revit' button"
            });
            reviews.push({
                "name": "Empty Example Reviewer",
                "picture": "https://picsum.photos/200/300",
                "stars": 5,
                "link": "",
                "update_time_human": "1 day ago",
                "comment": ""
            });
            if (viewMode === 'Dev') {
                reviews.push({
                    "name": "Empty Example Reviewer",
                    "picture": "https://picsum.photos/200/300",
                    "stars": 5,
                    "link": "",
                    "update_time_human": "1 day ago",
                    "comment": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vehicula imperdiet lectus, nec facilisis tortor malesuada at. Ut id vehicula est, nec placerat eros. Donec id justo sit amet leo convallis sollicitudin a vel purus. Suspendisse potenti. Praesent in vestibulum elit. Quisque vitae metus sit amet purus tempor aliquet. Nullam venenatis eros vel ex dictum, a suscipit lectus scelerisque. Morbi sagittis felis ut vehicula finibus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vehicula imperdiet lectus, nec facilisis tortor malesuada at. Ut id vehicula est, nec placerat eros. Donec id justo sit amet leo convallis sollicitudin a vel purus. Suspendisse potenti. Praesent in vestibulum elit. Quisque vitae metus sit amet purus tempor aliquet. Nullam venenatis eros vel ex dictum, a suscipit lectus scelerisque. Morbi sagittis felis ut vehicula finibus."
                });

                reviews.push({
                    "name": "Empty Example Reviewer",
                    "picture": "https://picsum.photos/200/300",
                    "stars": 5,
                    "link": "",
                    "update_time_human": "1 day ago",
                    "comment": "short text"
                });
            }
        }
        return {"reviews": reviews};
    }

    getRevitAttribute(key, defaultValue) {
        let result = null
        try {
            if (!!this.reviewsObj && !!this.reviewsObj.carousel_settings) {
                result = this.reviewsObj.carousel_settings[key];
            }
        } catch (e) {
            console.error(e);
        } finally {
            if (!result) {
                result = defaultValue;
            }
        }

        return result;
    }

    getStyles() {
        return `
    <style>
     .revit_carousel {
            width: 100%;
            min-height: 320px;
            font-size:12px;
        }

        @keyframes scroll {
            from {transform: translateX(0)}
            to {transform: translateX(-100%)}
        }
       .revit_carousel .revit_comment p {
            overflow: hidden;
            max-height: 7.675em;
        }
       .revit_carousel .revit_read_more {
            text-align: center;
            padding-top: 0.5em;
        }
        .revit_carousel a {
            color: inherit;
        }

       .revit_carousel .revit_track {
            display: flex;
            gap: 2rem;
        }
        .revit_carousel .revit_track:hover {
            animation-play-state: paused;
        }
        .revit_carousel .revit_card {
            background: ${this.getRevitAttribute('cardBg', "#FFFFFF")};
            color:  ${this.getRevitAttribute('cardTextColor', "#000000")};
            padding: 1.875em;
            width: 21.875em;
            height: 20.688em;
            box-shadow: 0 0.25em 0.25em rgba(0, 0, 0, 0.25);
            border-radius: ${this.getRevitAttribute('outerBorder', "16")}px;
            flex-shrink: 0;
        }
       .revit_carousel .grow {
            transition: all .2s ease-in-out;
        }
        .revit_carousel .grow:hover {
            transform: scale(1.1);
        }
        .revit_carousel .revit_stars_and_glogo {
            display: flex;
            justify-content: space-between;
        }
       .revit_carousel .revit_comment {
            background: ${this.getRevitAttribute('commentBackground', "#FFFFFF")};;
            padding: 1.25em;
            border-radius:  ${this.getRevitAttribute('innerBorder', "16")}px;
            border: 1px solid ${this.getRevitAttribute('cardBorderColor', "#000000")};;
            margin: 2.125em 1em 0 1em;
            font-size: 1em;
            box-shadow: 3px 4px 5px 0px rgba(0, 0, 0, 0.25);
            max-height:11.25em;
        }
        .revit_carousel .revit_card_bottom {
            display: flex;
            justify-content: center;
        }
        .revit_carousel .revit_user_image {
            width: 2.5em;
            height: 2.5em;
            border-radius: 50%;
        }
       .revit_carousel .revit_card_main {
            padding-bottom: 1em;
        }
       .revit_carousel .revit_user_data {
            display: flex;
            gap: 0.625em;
        }
       .revit_carousel .revit_star {
            width: 1.5em;
        }

        .revit_carousel .rvtFlex{
            display: flex;
        }

        .revit_carousel  .rvtSpaceBetween{
            justify-content: space-between;
        }

          .revit_carousel .mt-10{
                margin-top: 10px;
            }

        .revit_classic_comment_txt{
                max-height: 9em;
                overflow:hidden;
                        
        }

    </style>`
    }

    getGoogleLogo() {
        return `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_2_58)">
                    <path d="M23.766 12.2764C23.766 11.4607 23.6999 10.6406 23.5588 9.83807H12.24V14.4591H18.7217C18.4528 15.9494 17.5885 17.2678 16.323 18.1056V21.1039H20.19C22.4609 19.0139 23.766 15.9274 23.766 12.2764Z" fill="#4285F4"/>
                    <path d="M12.2401 24.0008C15.4766 24.0008 18.2059 22.9382 20.1945 21.1039L16.3276 18.1055C15.2517 18.8375 13.8627 19.252 12.2445 19.252C9.11388 19.252 6.45946 17.1399 5.50705 14.3003H1.5166V17.3912C3.55371 21.4434 7.7029 24.0008 12.2401 24.0008Z" fill="#34A853"/>
                    <path d="M5.50254 14.3003C4.99987 12.8099 4.99987 11.1961 5.50254 9.70575V6.61481H1.5165C-0.185503 10.0056 -0.185503 14.0004 1.5165 17.3912L5.50254 14.3003Z" fill="#FBBC04"/>
                    <path d="M12.2401 4.74966C13.9509 4.7232 15.6044 5.36697 16.8434 6.54867L20.2695 3.12262C18.1001 1.0855 15.2208 -0.034466 12.2401 0.000808666C7.7029 0.000808666 3.55371 2.55822 1.5166 6.61481L5.50264 9.70575C6.45064 6.86173 9.10947 4.74966 12.2401 4.74966Z" fill="#EA4335"/>
                </g>
            </svg>
        `;
    }

    getStar() {
        return `
            <svg class="revit_star" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="paint0_linear_2_61" x1="11" y1="0" x2="11" y2="20.6256" gradientUnits="userSpaceOnUse">
                        <stop offset="0.0333335" stop-color="${this.getRevitAttribute('starsColor', '#FFC700')}"/>
                        <stop offset="1" stop-color="${this.getBrighterColor(this.getRevitAttribute('starsColor', '#FFC700'), 40)}"/>
                    </linearGradient>
                </defs>
                <path d="M4.96463 20.5473C4.43389 20.8195 3.83164 20.3424 3.93889 19.7333L5.08013 13.2295L0.236023 8.61504C-0.216351 8.18329 0.0187734 7.39404 0.625147 7.30879L7.35988 6.3518L10.3629 0.402186C10.6337 -0.134062 11.3666 -0.134062 11.6375 0.402186L14.6405 6.3518L21.3752 7.30879C21.9816 7.39404 22.2167 8.18329 21.763 8.61504L16.9202 13.2295L18.0615 19.7333C18.1687 20.3424 17.5665 20.8195 17.0357 20.5473L10.9981 17.4453L4.96326 20.5473H4.96463Z" fill="url(#paint0_linear_2_61)"/>
            </svg>
        `;
    }

    getStars(amount) {
        let result = '';
        for (let i = 0; i < amount; i++) {
            result += this.getStar();
        }
        return result;
    }

    getBrighterColor(hexColor, factor) {
        const r = parseInt(hexColor.slice(1, 3), 16);
        const g = parseInt(hexColor.slice(3, 5), 16);
        const b = parseInt(hexColor.slice(5, 7), 16);

        const newR = Math.min(255, r + factor);
        const newG = Math.min(255, g + factor);
        const newB = Math.min(255, b + factor);

        return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
    }

    buildReviewCard(review) {
        let card = null;
        if (this.reviewsObj.carousel_settings?.layout === 'classic') {
            card = this.buildClassicCard(review);
        } else {
            card = this.buildFunCard(review);
        }
        return card;
    }

      buildClassicCard(review) {
        return `
            <div class="revit_card">
                <div class="rvtFlex rvtSpaceBetween">
                     <div class="revit_user_data">
                            <img class="revit_user_image" src="${review.picture}"/>
                            <div>
                                <div>${review.name}</div>
                                <div>${review.update_time_human}</div>
                            </div>
                     </div>
                     <div>
                            ${this.getGoogleLogo()}
                     </div>
                </div>
                <div class="mt-10">
                    <div class="stars">
                        ${this.getStars(review.stars)}
                    </div>
                </div>
                <div class="revit_clasic_comment mt-10">
                        <div class="revit_classic_comment_txt">${review.comment}</div>
                        <div class="mt-10">
                            <a href="${review.link}" target="_blank">${review.comment ? this.getRevitAttribute('readMore', "Read more") : ''}</a>
                        </div>
                </div>
            </div>
        `;
    }

    buildFunCard(review) {
        return `
            <div class="revit_card grow">
                <div class="revit_card_main">
                    <div class="revit_stars_and_glogo">
                        <div class="stars">
                            ${this.getStars(review.stars)}
                        </div>
                        <div>
                            ${this.getGoogleLogo()}
                        </div>
                    </div>
                    <div class="revit_comment">
                        <p>${review.comment}</p>
                        <div class="revit_read_more">
                            <a href="${review.link}" target="_blank">${review.comment ? this.getRevitAttribute('readMore', "Read more") : ''}</a>
                        </div>
                    </div>
                </div>
                <div class="revit_card_bottom">
                    <div class="revit_user_data">
                        <img class="revit_user_image" src="${review.picture}"/>
                        <div>
                            <div>${review.name}</div>
                            <div>${review.update_time_human}</div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    setSpeed(reviews) {
        try {
            let tempSpeed = parseInt(reviews?.carousel_settings?.carouselSpeed)
            if (typeof tempSpeed === 'number' && !isNaN(tempSpeed)) {
                console.log(`setting the speed ${tempSpeed}`)
                tempSpeed = tempSpeed / 10;
                this.revit_speed = tempSpeed;
            }
        } catch (e) {
            console.log(`failed to parse speed ${reviews?.carousel_settings}`)
        }
    }

    generateCards() {
        return this.reviewsObj.reviews?.map(r => this.buildReviewCard(r)).join('');
    }

    render() {
        this.innerHTML = `
            ${this.getStyles()}
            <div class="revit_carousel">
                <div class="revit_track">
                    ${this.generateCards()}
                </div>
            </div>
        `;

        this.initScrollValues();
        this.scrollCarousel();
    }

    initScrollValues() {
        this.revit_track = this.querySelector(".revit_track");
        this.revit_cards_items = this.querySelectorAll(".revit_card");

        if (this.revit_cards_items.length > 0) {
            this.revit_trackWidth = Array.from(this.revit_cards_items).reduce((acc, item) => acc + item.offsetWidth, 0);
        }

        this.revit_carousel_obj = this.querySelector(".revit_carousel");
        if (this.revit_carousel_obj) {
            this.revit_carousel_obj.addEventListener('mouseover', () => {
                this.revit_keepScrolling = false;
            });

            this.revit_carousel_obj.addEventListener('mouseout', () => {
                this.revit_keepScrolling = true;
            });

            this.revit_carouselWidth = this.revit_carousel_obj.offsetWidth;
        }
    }

    scrollCarousel() {
        this.revit_translateX -= this.revit_speed * this.revit_keepScrolling;
        if (-this.revit_translateX >= this.revit_trackWidth + this.revit_carouselWidth) {
            this.revit_translateX = 0;
        }
        if (this.revit_track) {
            this.revit_track.style.transform = `translateX(${this.revit_translateX}px)`;
        }

        let a = null;
        requestAnimationFrame(this.scrollCarousel.bind(this));
    }
}

customElements.define('review-carousel', RevitCarousel);
